import { useDialog } from '@rich-products-corp/primitives-richproducts';
import {
  RecipientsBookDialog,
  RecipientsBookDialogProps,
} from '../../../components/common/dialogs/address/recipients-book.dialog';

export function useRecipientsBookDialog(props: RecipientsBookDialogProps) {
  return useDialog(<RecipientsBookDialog {...props} />);
}
